import axios from 'axios';
import { API_BASE_URL } from './api';

// Funnel steps — keep in sync with Visit.STEP_CHOICES in document_processor/models.py
export const STEPS = {
  LANDED: 1,
  DOCUMENT_UPLOADED: 2,
  OLD_LOGO_PICKED: 3,
  PROCESSING: 4,
  DOWNLOADED: 5,
};

const VISIT_KEY = 'replogo_visit_id';

const newId = () =>
  (window.crypto && window.crypto.randomUUID)
    ? window.crypto.randomUUID()
    : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });

// One visit per browser tab: survives page changes and refreshes, resets in a new tab.
const getVisitId = () => {
  try {
    let id = sessionStorage.getItem(VISIT_KEY);
    if (!id) {
      id = newId();
      sessionStorage.setItem(VISIT_KEY, id);
    }
    return id;
  } catch (e) {
    if (!window.__replogoVisitId) window.__replogoVisitId = newId();
    return window.__replogoVisitId;
  }
};

// Fire-and-forget: tracking must never break or slow down the app.
export const trackStep = (step) => {
  axios
    .post(`${API_BASE_URL}/track/`, { visit_id: getVisitId(), step })
    .catch(() => {});
};
